import { BoxProps, styled } from 'styled-system/jsx';

export const BlackDot = ({ ...props }: BoxProps) => {
  return (
    <styled.span
      width="4px"
      height="4px"
      borderRadius="50%"
      bgColor="black"
      shadow="pressingLv1"
      {...props}
    />
  );
};
